// FETCH ALL WASHING INWARD DETAILS
export const FETCH_WASHING_INWARD_DETAILS_REQUEST_DK = 'FETCH_WASHING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_WASHING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_WASHING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_WASHING_INWARD_DETAILS_FAILURE_DK = 'FETCH_WASHING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL WASHING INWARD DETAILS
export const FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK = 'FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_REQUEST_DK';
export const FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK = 'FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_SUCCESS_DK';
export const FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK = 'FETCH_WASHING_INWARD_DETAILS_WITHOUT_ID_FAILURE_DK';

// CREATE WASHING INWARD DETAILS
export const CREATE_WASHING_INWARD_DETAILS_REQUEST_DK = 'CREATE_WASHING_INWARD_DETAILS_REQUEST_DK';
export const CREATE_WASHING_INWARD_DETAILS_SUCCESS_DK = 'CREATE_WASHING_INWARD_DETAILS_SUCCESS_DK';
export const CREATE_WASHING_INWARD_DETAILS_FAILURE_DK = 'CREATE_WASHING_INWARD_DETAILS_FAILURE_DK';

// UPDATE WASHING INWARD DETAILS
export const UPDATE_WASHING_INWARD_DETAILS_REQUEST_DK = 'UPDATE_WASHING_INWARD_DETAILS_REQUEST_DK';
export const UPDATE_WASHING_INWARD_DETAILS_SUCCESS_DK = 'UPDATE_WASHING_INWARD_DETAILS_SUCCESS_DK';
export const UPDATE_WASHING_INWARD_DETAILS_FAILURE_DK = 'UPDATE_WASHING_INWARD_DETAILS_FAILURE_DK';

// FETCH SINGLE STATE OF WASHING INWARD DETAILS
export const FETCH_SINGLE_WASHING_INWARD_DETAILS_REQUEST_DK = 'FETCH_SINGLE_WASHING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_SINGLE_WASHING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_SINGLE_WASHING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_SINGLE_WASHING_INWARD_DETAILS_FAILURE_DK = 'FETCH_SINGLE_WASHING_INWARD_DETAILS_FAILURE_DK';

// FETCH ALL PROPERTIES FROM WASHING_INWARD DETAILS
export const FETCH_PREVIOUS_WASHING_INWARD_DETAILS_REQUEST_DK = 'FETCH_PREVIOUS_WASHING_INWARD_DETAILS_REQUEST_DK';
export const FETCH_PREVIOUS_WASHING_INWARD_DETAILS_SUCCESS_DK = 'FETCH_PREVIOUS_WASHING_INWARD_DETAILS_SUCCESS_DK';
export const FETCH_PREVIOUS_WASHING_INWARD_DETAILS_FAILURE_DK = 'FETCH_PREVIOUS_WASHING_INWARD_DETAILS_FAILURE_DK';

// DELETE WASHING INWARD DETAILS
export const DELETE_WASHING_INWARD_DETAILS_REQUEST_DK = 'DELETE_WASHING_INWARD_DETAILS_REQUEST_DK';
export const DELETE_WASHING_INWARD_DETAILS_SUCCESS_DK = 'DELETE_WASHING_INWARD_DETAILS_SUCCESS_DK';
export const DELETE_WASHING_INWARD_DETAILS_FAILURE_DK = 'DELETE_WASHING_INWARD_DETAILS_FAILURE_DK';

export const RESET_WASHING_INWARD_DETAILS_INFO_DK = 'RESET_WASHING_INWARD_DETAILS_INFO_DK';

export const CREATE_WASHING_INWARD_DETAILS_FORM_DK = 'CREATE_WASHING_INWARD_DETAILS_FORM_DK';

export const UPDATE_WASHING_INWARD_DETAILS_FORM_DK = 'UPDATE_WASHING_INWARD_DETAILS_FORM_DK';
